module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"296600595354378"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
